

$(window).scroll(function () {
  
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 400) {
        maxHeight = 350;
    } else if (scrollTop > 5) {
        maxHeight = 350; 
    } else {
        maxHeight = 350 - 75 * ((scrollTop - 200)) / 200;
      	$('.site-header').css('top', '0px');
    }
    $('.hero__text-content').css({
        'max-height': maxHeight + "px"
    });

  
    if($(this).scrollTop() > 100)
		{
			if (!$('.site-header').hasClass('fixed'))
			{
				$('.site-header').stop().addClass('fixed').css('top', '-85px').animate(
					{
						'top': '0px'
					}, 500);
			}
		}
	else
		{
			$('.site-header').stop().removeClass('fixed');
		}
});


$(document).ready(function() {
  
  var elements = document.querySelectorAll('.sticky');
  Stickyfill.add(elements);
  
  $('.hidden').delay(200).fadeOut(500); 
  
   $('.accordion').accordion({
    	defaultOpen: 'section1',
    	cookieName: 'accordion_nav'
   });  

  
  
//SCROLL REVEAL
    window.sr = ScrollReveal();
    sr.reveal('.about-section, .get-in-touch, .index-sections .shopify-section, .flex, .grid__item.grid-product',
      { distance: '0px',
        scale: 0,
        duration: 1500,
        delay: 100
      }
    );  
  
});

